export default function MySQL_INNERJOIN() {
  return (
    <div>
      <h2>MySQL_INNERJOIN</h2>    </div>
  );
}